module.exports = __webpack_public_path__ + "static/media/messages.031a5c7e.png";